import React from "react";

export default function Tooltip({ children, lines = [] }) {
  return (
    <span className="relative inline-flex items-center leading-none align-middle group">
      {children}

      <span
        className="
            absolute left-full top-1/2 -translate-y-1/2 ml-2
            opacity-0 group-hover:opacity-100 pointer-events-none
            bg-white text-gray-700 text-[11px] leading-tight
            rounded px-2 py-1 shadow-md max-w-[220px] w-max
            whitespace-normal break-words [overflow-wrap:anywhere]
            transition-all duration-150
            flex flex-col gap-0.5 text-left
            z-50
          "
      >
        {lines.map((line, i) => (
          <span key={i} className="whitespace-normal break-words [overflow-wrap:anywhere]">
            {line}
          </span>
        ))}
      </span>
    </span>
  );
}
